import React from 'react';
import styled from 'styled-components';

export const InvalidFeedback = styled.span`
  display: block;
  width: 100%;
  margin-top: 0;
  font-size: 14px;
  line-height: 20px;
  margin-left: 8px;
  font-weight: 500;
  color: #f0323c;
  font-family: 'Satoshi', -apple-system, BlinkMacSystemFont, Roboto,
    Helvetica Neue, sans-serif !important;
`;

export const errorMessage = (errorMsg) => {
  return <InvalidFeedback>{errorMsg}</InvalidFeedback>;
};
